import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

function triggerBlobDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

async function parseBlobError(error) {
  if (error.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const parsed = JSON.parse(text);
      const message = parsed.message || parsed.detail || 'Request failed.';
      throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
    } catch (parseErr) {
      if (parseErr instanceof Error && parseErr.message && !parseErr.message.includes('JSON')) {
        throw parseErr;
      }
      throw new Error('Request failed.');
    }
  }
  throw error;
}

async function postPdfTool(cookies, action, formData, filename) {
  try {
    const response = await getApiClient(cookies).post(
      `${apiBaseUrl}/pdf_utility/${action}/`,
      formData,
      { responseType: 'blob' },
    );
    triggerBlobDownload(response.data, filename);
    return response.data;
  } catch (error) {
    await parseBlobError(error);
    throw error;
  }
}

export function mergePdfs(cookies, files) {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  return postPdfTool(cookies, 'merge', formData, 'merged.pdf');
}

export function imagesToPdf(cookies, files) {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  return postPdfTool(cookies, 'image_to_pdf', formData, 'images.pdf');
}

export function excelToPdf(cookies, file) {
  const formData = new FormData();
  formData.append('files', file);
  return postPdfTool(cookies, 'excel_to_pdf', formData, 'spreadsheet.pdf');
}

export function compressPdf(cookies, file) {
  const formData = new FormData();
  formData.append('files', file);
  return postPdfTool(cookies, 'compress', formData, 'compressed.pdf');
}

export async function getPdfInfo(cookies, file) {
  const formData = new FormData();
  formData.append('files', file);
  try {
    const response = await getApiClient(cookies).post(
      `${apiBaseUrl}/pdf_utility/info/`,
      formData,
    );
    return response.data;
  } catch (error) {
    await parseBlobError(error);
    throw error;
  }
}

export function editPdf(cookies, file, { pageOrder, rotations, stampText }) {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('page_order', JSON.stringify(pageOrder || []));
  formData.append('rotations', JSON.stringify(rotations || {}));
  if (stampText) {
    formData.append('stamp_text', stampText);
  }
  return postPdfTool(cookies, 'edit', formData, 'edited.pdf');
}
